import { CommunicationHistory } from 'app/components/CommunicationHistory';

const CommunicationHistoryPage = () => {
  return <CommunicationHistory />;
};

export default CommunicationHistoryPage;
